import Preloader from 'vcomponents/utilities/Preloader.vue';
var SettingsFormMixin = {
    props: {
        cardCustomSettings: {
            type: [Object, Array],
            required: true,
            default: () => {
                return {};
            },
        },
        cardName: {
            type: String,
            required: true,
        },
        cardSettings: {
            type: Object,
            required: false,
            default() {
                return {};
            },
        },
        form: {
            type: Object,
            required: true,
        },
        loading: {
            type: Boolean,
            required: true,
        },
    },
    data() {
        return {
            settings: Array.isArray(this.cardCustomSettings) ? {} : this.cardCustomSettings,
        };
    },
    components: {
        Preloader,
    },
};
export default SettingsFormMixin;
